import Modal from "../shared/Modal";
import "./ModalDeleteResourceFolderConfirm.css";

type ModalDeleteResourceFolderConfirmProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  folderName: string;
  fileCount: number;
};

const ModalDeleteResourceFolderConfirm = ({
  isOpen,
  onClose,
  onContinue,
  folderName,
  fileCount,
}: ModalDeleteResourceFolderConfirmProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-collection-delete-resource-folder-confirm">
          <div className="modal-collection-delete-resource-folder-confirm-title">
            Delete This Folder
          </div>

          <div className="modal-collection-delete-resource-folder-confirm-content">
            This resource was added from the folder: {folderName}
            <p />
            Would you like to delete from this workspace all {fileCount}{" "}
            resources that were added from this folder. Deleted content will be
            removed from Winslow and questions will no longer be able to
            reference the knowledge in them. You can add these resources back
            again at any time.
          </div>

          <div className="modal-collection-delete-resource-folder-confirm-footer">
            <div className="modal-collection-delete-resource-folder-confirm-buttons">
              <button onClick={onClose} className="collections-button-negative">
                Cancel
              </button>
              <button
                onClick={() => onContinue()}
                className="collections-button">
                Delete {fileCount} Resources
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalDeleteResourceFolderConfirm;
